/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, ComponentRef, Input, OnChanges, OnDestroy, Type, ViewContainerRef, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';

@Component({
    selector: 'app-widget-content-holder',
    templateUrl: './widget-content-holder.html',
    imports: [RouterLink],
    styleUrl: './widget-content-holder.scss'
})
export class WidgetContentHolderComponent implements OnChanges, OnDestroy {
    viewContainerRef = inject(ViewContainerRef);


    @Input() componentType!: Type<IWidget>
    @Input() chosenWidget: ChosenWidget;
    componentRef: ComponentRef<IWidget>;
    title = ''
    subTitle: string;
    routerLink: any[];


    initialized = false;

    /*
    * Switched to OnChanges because angular content project will always initialize content immediately
    * So even if content is inside an if statement, it gets initialized
    * So projected formContent initializes before the initComplete has been fired
    * This change allows the components to be rendered as the content gets controls get created.
    */
    ngOnChanges(): void {
        this.ngOnDestroy();
        this.componentRef = this.viewContainerRef.createComponent(this.componentType);
        this.componentRef.instance.chosenWidget = this.chosenWidget;
        this.routerLink = this.componentRef.instance.routerLink;
        this.title = this.componentRef.instance.title;
        this.subTitle = this.componentRef.instance.subTitle;
    }

    ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }    
}
